import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Filter, Eye, Download } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { StatusBadge } from "@/pages/platforms/SuiviDepot";

export default function DepositsList() {
  const [items, setItems] = useState([]);
  const [kind, setKind] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (kind) params.kind = kind;
      if (status) params.status = status;
      const { data } = await api.get("/deposits", { params });
      setItems(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, [kind, status]);

  return (
    <div data-testid="deposits-list">
      <div className="eyebrow eyebrow-dark">Service des Dépôts</div>
      <h1 className="mt-2 text-3xl font-bold text-unisic-blue">Dépôts académiques</h1>
      <span className="divider-gold mt-3" />

      <div className="mt-8 flex gap-3 flex-wrap items-center">
        <div className="flex items-center gap-2 text-xs text-slate-500"><Filter className="w-3.5 h-3.5" /> Filtres</div>
        <select value={kind} onChange={(e) => setKind(e.target.value)} className="border border-slate-300 px-3 py-2 rounded-sm text-sm bg-white" data-testid="filter-kind">
          <option value="">Tous types</option>
          <option value="memoire">Mémoire</option>
          <option value="projet_tutore">Projet tutoré</option>
        </select>
        <select value={status} onChange={(e) => setStatus(e.target.value)} className="border border-slate-300 px-3 py-2 rounded-sm text-sm bg-white" data-testid="filter-status">
          <option value="">Tous statuts</option>
          {["Dépôt reçu", "Contrôle administratif", "Test anti-plagiat", "En cours d'analyse", "Validé", "Validé sous réserve", "À corriger", "Refusé", "Archivé"].map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      <div className="mt-6 paper-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="unisic-table w-full">
            <thead className="bg-slate-50 border-b border-slate-200">
              <tr>
                <th className="px-4 py-3">Numéro</th>
                <th className="px-4 py-3">Type</th>
                <th className="px-4 py-3">Auteur</th>
                <th className="px-4 py-3">Sujet</th>
                <th className="px-4 py-3">Département</th>
                <th className="px-4 py-3">Statut</th>
                <th className="px-4 py-3 text-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={7} className="text-center py-10 text-slate-500">Chargement...</td></tr>
              )}
              {!loading && items.length === 0 && (
                <tr><td colSpan={7} className="text-center py-10 text-slate-500">Aucun dépôt.</td></tr>
              )}
              {items.map((d) => (
                <tr key={d.id} className="hover:bg-slate-50" data-testid={`deposit-row-${d.id}`}>
                  <td className="px-4 py-3 font-mono text-xs text-unisic-blue">{d.tracking_number}</td>
                  <td className="px-4 py-3 capitalize">{d.kind === "memoire" ? "Mémoire" : "Projet tutoré"}</td>
                  <td className="px-4 py-3">{d.student_name || d.group_name || d.group_leader}</td>
                  <td className="px-4 py-3 max-w-xs truncate">{d.subject}</td>
                  <td className="px-4 py-3">{d.department}</td>
                  <td className="px-4 py-3"><StatusBadge status={d.status} /></td>
                  <td className="px-4 py-3 text-right">
                    <div className="flex gap-2 justify-end">
                      {d.file_path && (
                        <a href={fileUrl(d.file_path)} target="_blank" rel="noopener noreferrer" className="p-1.5 border border-slate-300 rounded-sm hover:border-unisic-gold" title="Télécharger PDF" data-testid={`btn-download-${d.id}`}>
                          <Download className="w-3.5 h-3.5" />
                        </a>
                      )}
                      <Link to={`/dashboard/depots/${d.id}`} className="p-1.5 border border-slate-300 rounded-sm hover:border-unisic-gold" title="Voir" data-testid={`btn-view-${d.id}`}>
                        <Eye className="w-3.5 h-3.5" />
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
